import React from "react";
import { Link } from "@/i18n/router";
import { ChevronRight } from "lucide-react";
import { Overline } from "@/components/ui/primitives";
import { useLang } from "@/i18n/LanguageContext";

export function PageHero({ overline, title, subtitle, breadcrumbs = [], children }) {
  const { tr } = useLang();
  return (
    <section className="relative overflow-hidden border-b border-navy-border bg-navy pt-[72px]" data-testid="page-hero">
      <div className="absolute inset-0 bg-grid opacity-20" aria-hidden="true" />
      <div className="radial-glow absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8 py-20 lg:py-28">
        {breadcrumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="mb-6">
            <ol className="flex flex-wrap items-center gap-1 text-sm text-silver/50">
              <li><Link to="/" className="hover:text-white transition-colors">{tr("Home")}</Link></li>
              {breadcrumbs.map((b, i) => (
                <li key={i} className="flex items-center gap-1">
                  <ChevronRight className="h-3.5 w-3.5" />
                  {b.to ? <Link to={b.to} className="hover:text-white transition-colors">{b.label}</Link> : <span className="text-silver/80">{b.label}</span>}
                </li>
              ))}
            </ol>
          </nav>
        )}
        {overline && <Overline>{overline}</Overline>}
        <h1 className="mt-4 max-w-4xl font-heading text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter leading-[1.05] text-white">
          {title}
        </h1>
        {subtitle && <p className="mt-6 max-w-2xl text-lg md:text-xl leading-relaxed text-silver/70">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
